<template>
  <div class="collect-fee">
     
      <v-card class="mx-4 my-4 px-4 py-4">
        <h2 class="text-left mb-2">Transaction Details</h2>
        <v-divider class="mb-6"></v-divider>
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <p class="text-left">
              Student Name :
              <b>{{ feeCollectionData.profile.user.full_name }}</b>
            </p>
            <p class="text-left">
              Roll number :
              <b>{{ feeCollectionData.profile.user.roll_number }}</b>
            </p>
            <p class="text-left">
              Total Paying :
              <b>{{ feeCollectionData.is_custom ?  currencyFormat(totalSum(feeCollectionData.instalments, 'paying')) :currencyFormat(totalSum(feeCollectionData.schedule_instalment.instalments, 'paying')) }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <p class="text-left">
              Payment Date :
              <b>{{ moment(feeCollectionData.payment_date).format('DD MMM YYYY') }}</b>
            </p>
            <p class="text-left">
              Class :
              <b>{{feeCollectionData.feeAccount.room.sections}}</b>
            </p>
          </v-col>
        </v-row>
      </v-card>

      <v-btn color="red" class="white--text mb-3" @click="cancelFeeCollection">Cancel</v-btn>
      
      <v-expansion-panels v-model="expanded" popout focusable v-if="feeReceiptSettings">
        <!-- Cash -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <b>Cash</b>
          </v-expansion-panel-header>
          <v-expansion-panel-content> 
          
              <v-row>
                <v-col cols="12" :md="feeCollectionData.category.multiple_receipt_settings ? 6 : 4" 
                  v-if="feeCollectionData.category.multiple_receipt_settings"
                >
                  <v-select
                    label="Receipt Settings"
                    v-model="selected_fee_receipt_settings"
                    persistent-hint
                    :items="feeReceiptSettings"
                    :rules="[rules.required]"
                    outlined
                    dense
                    class="rounded-input"
                    item-value="id"
                    @change="setFeeReceiptNumber"
                    item-text="title"
                    return-object
                    :disabled="(feeCollectionData.selected_fee_particular_tag && feeCollectionData.selected_fee_particular_tag.preferred_fee_receipt_settings) ? true : false"
                  >
                  </v-select>
                </v-col>                
                <v-col cols="12" :md="feeCollectionData.category.multiple_receipt_settings ? 6 : 4">
                  <v-text-field
                    label="Receipt Number"
                    :readonly="!(selected_fee_receipt_settings && selected_fee_receipt_settings.allow_custom_fee_receipt_numbers)"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    v-model="mode.receipt_number"
                    maxlength="50"
                    :error-messages="receiptNumberError"
                    @input="receiptNumberError=null"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" :md="feeCollectionData.category.multiple_receipt_settings ? 12 : 8">
                  <v-textarea
                    outlined
                    rows="1"
                    auto-grow
                    dense
                    class="rounded-input"
                    label="Remarks"
                    v-model="mode.remarks"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4" v-if="financePreferences && financePreferences.link_fees">
                  <v-autocomplete
                    v-model="selected_finance_account"
                    :rules="[rules.required]"
                    label="Credit Account"
                    :items="financeAccounts"
                    item-text="name"
                    item-value="id"
                    outlined
                    class="rounded-input"
                    dense
                  >
                  </v-autocomplete>
                </v-col>
                
                <v-col cols="12">
                  <v-btn
                    @click="checkReceiptNumberExists"
                    :disabled="isLoading || !(mode.receipt_number && (!financePreferences || !financePreferences.link_fees || financePreferences.link_fees && selected_finance_account))"
                    color="primary"
                  >Save</v-btn>
                </v-col>
              </v-row>
            
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- Cheque -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <b>Cheque</b>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
          
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.cheque_number"
                    label="Cheque Number"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="mode.cheque_issued_to"
                    label="Issued To"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    label="Bank Name"
                    v-model="mode.bank_name"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="mb-0">
                  <v-menu
                    ref="cheque_menu"
     
                    v-model="cheque_menu"
                    :close-on-content-click="false"
                    :return-value.sync="mode.cheque_date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedDate(mode.cheque_date)"
                        append-icon="fas fa-calendar"
                        readonly
                        outlined
                        dense
                        :rules="[rules.required]"
                        class="rounded-input"
                        label="Cheque date"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="mode.cheque_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="cheque_menu = false">Cancel</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.cheque_menu.save(mode.cheque_date)"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="mode.bank_branch"
                    label="Branch"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" 
                  v-if="feeCollectionData.category.multiple_receipt_settings"
                >
                  <v-select
                    label="Receipt Settings"
                    v-model="selected_fee_receipt_settings"
                    persistent-hint
                    :items="feeReceiptSettings"
                    :rules="[rules.required]"
                    outlined
                    dense
                    class="rounded-input"
                    item-value="id"
                    @change="setFeeReceiptNumber"
                    item-text="title"
                    return-object
                    :disabled="(feeCollectionData.selected_fee_particular_tag && feeCollectionData.selected_fee_particular_tag.preferred_fee_receipt_settings) ? true : false"
                  >
                  </v-select>
                </v-col>  
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.receipt_number"
                    maxlength="50"
                    :error-messages="receiptNumberError"
                    @input="receiptNumberError=null"
                    label="Receipt Number"
                    :readonly="!(selected_fee_receipt_settings && selected_fee_receipt_settings.allow_custom_fee_receipt_numbers)"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="8">
                  <v-textarea
                    v-model="mode.remarks"
                    outlined
                    rows="1"
                    auto-grow
                    dense
                    class="rounded-input"
                    label="Remarks"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4" v-if="financePreferences && financePreferences.link_fees">
                  <v-autocomplete
                    v-model="selected_finance_account"
                    :rules="[rules.required]"
                    label="Credit Account"
                    :items="financeAccounts"
                    item-text="name"
                    item-value="id"
                    outlined
                    class="rounded-input"
                    dense
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-col cols="12">
                <v-btn
                  @click="checkReceiptNumberExists"
                  :disabled="isLoading || !(mode.cheque_number && mode.cheque_issued_to && mode.bank_name && mode.bank_branch && mode.cheque_date && mode.receipt_number && (!financePreferences || !financePreferences.link_fees || financePreferences.link_fees && selected_finance_account))"
                  color="primary"
                >Save</v-btn>
              </v-col>
            
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- DD -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <b>DD</b>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
          
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.dd_number"
                    label="DD Number"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="mode.dd_issued_to"
                    label="Issued To"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="mode.bank_name"
                    label="Bank Name"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="mb-0">
                  <v-menu
                    ref="dd_menu"
                    v-model="dd_menu"
                    :close-on-content-click="false"
                    :return-value.sync="mode.dd_date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedDate(mode.dd_date)"
                        append-icon="fas fa-calendar"
                        readonly
                        outlined
                        dense
                        :rules="[rules.required]"
                        class="rounded-input"
                        label="DD Date"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="mode.dd_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dd_menu = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.dd_menu.save(mode.dd_date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="mode.bank_branch"
                    label="Branch"
                    color="primary"
                    outlined
                    dense
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" 
                  v-if="feeCollectionData.category.multiple_receipt_settings"
                >
                  <v-select
                    label="Receipt Settings"
                    v-model="selected_fee_receipt_settings"
                    persistent-hint
                    :items="feeReceiptSettings"
                    :rules="[rules.required]"
                    outlined
                    dense
                    class="rounded-input"
                    item-value="id"
                    @change="setFeeReceiptNumber"
                    item-text="title"
                    return-object
                    :disabled="(feeCollectionData.selected_fee_particular_tag && feeCollectionData.selected_fee_particular_tag.preferred_fee_receipt_settings) ? true : false"
                  >
                  </v-select>
                </v-col>  
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.receipt_number"
                    maxlength="50"
                    :error-messages="receiptNumberError"
                    @input="receiptNumberError=null"
                    label="Receipt Number"
                    :readonly="!(selected_fee_receipt_settings && selected_fee_receipt_settings.allow_custom_fee_receipt_numbers)"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="8">
                  <v-textarea
                    v-model="mode.remarks"
                    outlined
                    rows="1"
                    auto-grow
                    dense
                    class="rounded-input"
                    label="Remarks"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4" v-if="financePreferences && financePreferences.link_fees">
                  <v-autocomplete
                    v-model="selected_finance_account"
                    :rules="[rules.required]"
                    label="Credit Account"
                    :items="financeAccounts"
                    item-text="name"
                    item-value="id"
                    outlined
                    class="rounded-input"
                    dense
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-col cols="12">
                <v-btn
                  @click="checkReceiptNumberExists"
                  :disabled="isLoading || !(mode.dd_number && mode.dd_issued_to && mode.bank_name && mode.bank_branch && mode.dd_date && mode.receipt_number && (!financePreferences || !financePreferences.link_fees || financePreferences.link_fees && selected_finance_account))"
                  color="primary"
                >Save</v-btn>
              </v-col>
            
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- NEFT/RTGS -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <b>NEFT/RTGS</b>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
          
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.utr_number"
                    label="UTR Number"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="mode.bank_name"
                    label="Bank Name"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" 
                  v-if="feeCollectionData.category.multiple_receipt_settings"
                >
                  <v-select
                    label="Receipt Settings"
                    v-model="selected_fee_receipt_settings"
                    persistent-hint
                    :items="feeReceiptSettings"
                    :rules="[rules.required]"
                    outlined
                    dense
                    class="rounded-input"
                    item-value="id"
                    @change="setFeeReceiptNumber"
                    item-text="title"
                    return-object
                    :disabled="(feeCollectionData.selected_fee_particular_tag && feeCollectionData.selected_fee_particular_tag.preferred_fee_receipt_settings) ? true : false"
                  >
                  </v-select>
                </v-col>  
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.receipt_number"
                    maxlength="50"
                    :error-messages="receiptNumberError"
                    @input="receiptNumberError=null"
                    label="Receipt Number"
                    :readonly="!(selected_fee_receipt_settings && selected_fee_receipt_settings.allow_custom_fee_receipt_numbers)"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="8">
                  <v-textarea
                    v-model="mode.remarks"
                    outlined
                    rows="1"
                    auto-grow
                    dense
                    class="rounded-input"
                    label="Remarks"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4" v-if="financePreferences && financePreferences.link_fees">
                  <v-autocomplete
                    v-model="selected_finance_account"
                    :rules="[rules.required]"
                    label="Credit Account"
                    :items="financeAccounts"
                    item-text="name"
                    item-value="id"
                    outlined
                    class="rounded-input"
                    dense
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-col cols="12">
                <v-btn
                  @click="checkReceiptNumberExists"
                  :disabled="isLoading || !(mode.utr_number && mode.bank_name && mode.receipt_number && (!financePreferences || !financePreferences.link_fees || financePreferences.link_fees && selected_finance_account))"
                  color="primary"
                >Save</v-btn>
              </v-col>
            
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- Online/Net Banking -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <b>Online/Net Banking</b>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
          
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.transaction_id"
                    label="Transaction ID"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="mode.bank_name"
                    label="Bank Name"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" 
                  v-if="feeCollectionData.category.multiple_receipt_settings"
                >
                  <v-select
                    label="Receipt Settings"
                    v-model="selected_fee_receipt_settings"
                    persistent-hint
                    :items="feeReceiptSettings"
                    :rules="[rules.required]"
                    outlined
                    dense
                    class="rounded-input"
                    item-value="id"
                    @change="setFeeReceiptNumber"
                    item-text="title"
                    return-object
                    :disabled="(feeCollectionData.selected_fee_particular_tag && feeCollectionData.selected_fee_particular_tag.preferred_fee_receipt_settings) ? true : false"
                  >
                  </v-select>
                </v-col>  
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.receipt_number"
                    maxlength="50"
                    :error-messages="receiptNumberError"
                    @input="receiptNumberError=null"
                    label="Receipt Number"
                    :readonly="!(selected_fee_receipt_settings && selected_fee_receipt_settings.allow_custom_fee_receipt_numbers)"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="8">
                  <v-textarea
                    v-model="mode.remarks"
                    outlined
                    rows="1"
                    auto-grow
                    dense
                    class="rounded-input"
                    label="Remarks"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4" v-if="financePreferences && financePreferences.link_fees">
                  <v-autocomplete
                    v-model="selected_finance_account"
                    :rules="[rules.required]"
                    label="Credit Account"
                    :items="financeAccounts"
                    item-text="name"
                    item-value="id"
                    outlined
                    class="rounded-input"
                    dense
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-col cols="12">
                <v-btn
                  @click="checkReceiptNumberExists"
                  :disabled="isLoading || !(mode.transaction_id && mode.bank_name && mode.receipt_number && (!financePreferences || !financePreferences.link_fees || financePreferences.link_fees && selected_finance_account))"
                  color="primary"
                >Save</v-btn>
              </v-col>
            
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- Debit Card -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <b>Debit Card</b>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
          
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.transaction_id"
                    label="Transaction ID"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="mode.bank_name"
                    label="Bank Name"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" 
                  v-if="feeCollectionData.category.multiple_receipt_settings"
                >
                  <v-select
                    label="Receipt Settings"
                    v-model="selected_fee_receipt_settings"
                    persistent-hint
                    :items="feeReceiptSettings"
                    :rules="[rules.required]"
                    outlined
                    dense
                    class="rounded-input"
                    item-value="id"
                    @change="setFeeReceiptNumber"
                    item-text="title"
                    return-object
                    :disabled="(feeCollectionData.selected_fee_particular_tag && feeCollectionData.selected_fee_particular_tag.preferred_fee_receipt_settings) ? true : false"
                  >
                  </v-select>
                </v-col>  
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.receipt_number"
                    maxlength="50"
                    :error-messages="receiptNumberError"
                    @input="receiptNumberError=null"
                    label="Receipt Number"
                    :readonly="!(selected_fee_receipt_settings && selected_fee_receipt_settings.allow_custom_fee_receipt_numbers)"
                    color="primary"
                    outlined
                    dense
                    :rules="[rules.required]"
                    class="rounded-input"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="8">
                  <v-textarea
                    v-model="mode.remarks"
                    outlined
                    rows="1"
                    auto-grow
                    dense
                    class="rounded-input"
                    label="Remarks"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4" v-if="financePreferences && financePreferences.link_fees">
                  <v-autocomplete
                    v-model="selected_finance_account"
                    :rules="[rules.required]"
                    label="Credit Account"
                    :items="financeAccounts"
                    item-text="name"
                    item-value="id"
                    outlined
                    class="rounded-input"
                    dense
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-col cols="12">
                <v-btn
                  @click="checkReceiptNumberExists"
                  :disabled="isLoading || !(mode.transaction_id && mode.bank_name && mode.receipt_number && (!financePreferences || !financePreferences.link_fees || financePreferences.link_fees && selected_finance_account))"
                  color="primary"
                >Save</v-btn>
              </v-col>
            
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- Credit Card -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <b>Credit Card</b>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
          
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.transaction_id"
                    :rules="[rules.required]"
                    label="Transaction ID"
                    color="primary"
                    outlined
                    dense
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="mode.bank_name"
                    :rules="[rules.required]"
                    label="Bank Name"
                    color="primary"
                    outlined
                    dense
                    class="rounded-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" 
                  v-if="feeCollectionData.category.multiple_receipt_settings"
                >
                  <v-select
                    label="Receipt Settings"
                    v-model="selected_fee_receipt_settings"
                    persistent-hint
                    :items="feeReceiptSettings"
                    :rules="[rules.required]"
                    outlined
                    dense
                    class="rounded-input"
                    item-value="id"
                    @change="setFeeReceiptNumber"
                    item-text="title"
                    return-object
                    :disabled="(feeCollectionData.selected_fee_particular_tag && feeCollectionData.selected_fee_particular_tag.preferred_fee_receipt_settings) ? true : false"
                  >
                  </v-select>
                </v-col>  
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="mode.receipt_number"
                    maxlength="50"
                    :error-messages="receiptNumberError"
                    @input="receiptNumberError=null"
                    label="Receipt Number"
                    :readonly="!(selected_fee_receipt_settings && selected_fee_receipt_settings.allow_custom_fee_receipt_numbers)"
                    :rules="[rules.required]"
                    color="primary"
                    outlined
                    dense
                    class="rounded-input"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="8">
                  <v-textarea
                    v-model="mode.remarks"
                    outlined
                    rows="1"
                    dense
                    auto-grow
                    class="rounded-input"
                    label="Remarks"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4" v-if="financePreferences && financePreferences.link_fees">
                  <v-autocomplete
                    v-model="selected_finance_account"
                    :rules="[rules.required]"
                    label="Credit Account"
                    :items="financeAccounts"
                    item-text="name"
                    item-value="id"
                    outlined
                    class="rounded-input"
                    dense
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-col cols="12">
                <v-btn
                  @click="checkReceiptNumberExists"
                  :disabled="isLoading || !(mode.transaction_id && mode.bank_name && mode.receipt_number && (!financePreferences || !financePreferences.link_fees || financePreferences && financePreferences.link_fees && selected_finance_account))"
                  color="primary"
                >Save</v-btn>
              </v-col>
            
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
         <v-snackbar v-model="snackbar.visible">
          {{ snackbar.text }}
          <template>
            <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
          </template>
        </v-snackbar>
        <ConfirmationDialog
          title="Are you sure you want to save the transaction and proceed to generate fee receipt?"
          successText="Proceed"
          @successCallback="saveFeeTransactions"
          failureText="Cancel"
          @failureCallback="showConfirmationDialog = false"
          :visible="showConfirmationDialog"
        />
        <ConfirmationDialog
          title="Warning!"
          description="Duplicate Fee Receipt Number Warning! If you continue, the receipt will be saved with the duplicate receipt number. This action is strongly discouraged."
          successText="Proceed"
          @successCallback="confirmDuplication()"
          failureText="Cancel"
          @failureCallback="duplicatReceiptNumberConfirmationDialog = false;"
          :visible="duplicatReceiptNumberConfirmationDialog"
        />
     
  </div>
</template>
<script>
import Helper from "@utils/misc";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import api from "@api/index";
import endpoints from "@api/repository";
import ConfirmationDialog from '@components/widgets/dialogs/ConfirmationDialog';

export default {
  name: "CollectFee",
  props: ["total_payable"],
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      expanded: null,
      dd_menu: false,
      cheque_menu: false,
      receiptNumberError: null,
      duplicatReceiptNumberConfirmationDialog: false,
      skipDuplicate: false,
      moment: moment,
      rules: {
        required: (value) => !!value || "Required.",

      },
      financePreferences: null,
      financeAccounts: [],
      mode: {
        type: null,
        remarks: null,
        bank_name: null,
        bank_branch: null,
        receipt_number: null,
        cheque_number: null,
        cheque_issued_to: null,
        cheque_date: null,
        dd_number: null,
        dd_issued_to: null,
        dd_date: null,
        utr_number: null,
        transaction_id: null,
      },
      selected_finance_account: null,
      selected_fee_receipt_settings: null,
      showConfirmationDialog: false, 
      feeReceiptSettings: null,
      snackbar: {
        visible: false,
        message: "",
      }
    };
  },
  computed: {
    ...mapGetters([
      "feeCollectionData",
      "accessToken",
      "currentUser",
      "currentInstitution",
      "isLoading",
      "activeFeeSession",
    ]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading","clearFeeCollectionData"]),
    totalSum(items, prop) {
      return Helper.totalSum(items, prop);
    },
    currencyFormat(amount) {
      return Helper.currencyFormat(amount);
    },
    formattedDate(date) {
      if (date == null) return "";
      return moment(date).format("DD-MM-YYYY");
    },

    async getAgrn(){
      var url = Helper.addUrlParams(endpoints.getFeeReceiptSettings,[`session=${this.activeFeeSession.id}`,`category=${this.feeCollectionData.category.id}`])
      this.feeReceiptSettings = await api.call(this.essentials,url)


      if ((!this.feeCollectionData.category.multiple_receipt_settings)){
        this.selected_fee_receipt_settings = Helper.clone(this.feeReceiptSettings)
        this.selected_fee_receipt_settings.value++
        // this.feeReceiptSettings.value++;
        this.mode.receipt_number = `${this.selected_fee_receipt_settings.prefix}${String(this.selected_fee_receipt_settings.value).padStart(this.selected_fee_receipt_settings.leading_zeros_length, 0)}${this.selected_fee_receipt_settings.suffix}`;
      }

      // if(this.feeCollectionData.selected_fee_particular_tag.preferred_fee_receipt_settings + 1){
      //   console.log("test")
      //   this.mode.receipt_number = this.feeReceiptSettings.find(rs => rs.id == this.feeCollectionData.selected_fee_particular_tag.preferred_fee_receipt_settings)

      //   console.log("preferred receipt number: ", this.mode.receipt_number)
      // }

      
    },


    setFeeReceiptNumber(){

      let feeReceiptSettings = Helper.clone(this.selected_fee_receipt_settings); 
      feeReceiptSettings.value++;
      this.mode.receipt_number = `${feeReceiptSettings.prefix}${String(feeReceiptSettings.value).padStart(feeReceiptSettings.leading_zeros_length, 0)}${feeReceiptSettings.suffix}`;  
    },

    async cancelFeeCollection (){ 
      var student_id = this.feeCollectionData.profile.user.id;
      this.clearFeeCollectionData();
      this.$router.push({ name: 'StudentFeeDetails', params: { sid: student_id } });
    },

    confirmDuplication(){ 
      this.duplicatReceiptNumberConfirmationDialog = false;
      // this.saveFeeTransactions();
      this.showConfirmationDialog = true;
    },

    async checkReceiptNumberExists(){
      var url = Helper.addUrlParams(endpoints.checkFeeReceiptNumberExists, `receipt_number=${this.mode.receipt_number}`)
      if((await api.call(this.essentials, url)) == true ){
        this.skipDuplicate = false;
        this.receiptNumberError = "Duplicate Receipt Number"
        this.duplicatReceiptNumberConfirmationDialog = true;
      }
      else{
        this.showConfirmationDialog = true;
      }
    },

    // async validateReceiptNumber(){
    //   this.checkReceiptNumberExists(this.mode.receipt_number);
    // },

    async saveFeeTransactions() {
      this.showConfirmationDialog = false;
      // if (!this.checkReceiptNumberExists(Helper.clone(this.mode.receipt_number))){
      console.log("submit")
      var mode = this.getModeData();
      var body = {
        fee_collection_data: this.feeCollectionData,
        mode: mode,
        credit_account: this.selected_finance_account, 
        fee_receipt_settings: this.selected_fee_receipt_settings.id,
        session: this.activeFeeSession.id,
      };
      console.log(body);
      var response = await api.call(
        this.essentials,
        endpoints.saveStudentFeeTransactions,
        api.Methods.POST,
        body
      );
      if (response) {
        // console.log(response);
        this.$router.push({ name: "ViewFeesPaid", params: {sid: this.feeCollectionData.profile.user.id, rid: response.id}});
        this.clearFeeCollectionData();
      }
    // }
      
    },

  
    getModeData() {
      const TransactionModes = Object.freeze({
        0: "CASH",
        1: "CHEQUE",
        2: "DD",
        3: "NEFT/RTGS",
        4: "ONLINE/NET BANKING",
        5: "DEBIT CARD",
        6: "CREDIT CARD",
      });

      var transactionModeObject = null;
      console.log(TransactionModes[this.expanded]);
      switch (TransactionModes[this.expanded]) {
        case "CASH": {
          transactionModeObject = {
            type: this.expanded,
            receipt_number: this.mode.receipt_number,
            remarks: this.mode.remarks,
          };
          break;
        }
        case "CHEQUE": {
          transactionModeObject = {
            type: this.expanded,
            cheque_number: this.mode.cheque_number,
            cheque_issued_to: this.mode.cheque_issued_to,
            bank_name: this.mode.bank_name,
            bank_branch: this.mode.bank_branch,
            cheque_date: this.mode.cheque_date,
            receipt_number: this.mode.receipt_number,
            remarks: this.mode.remarks,
          };
           break;
        }
        case "DD": {
          transactionModeObject = {
            type: this.expanded,
            dd_number: this.mode.dd_number,
            dd_issued_to: this.mode.dd_issued_to,
            bank_name: this.mode.bank_name,
            bank_branch: this.mode.bank_branch,
            dd_date: this.mode.dd_date,
            receipt_number: this.mode.receipt_number,
            remarks: this.mode.remarks,
          };
          break;
        }
        case "NEFT/RTGS": {
          transactionModeObject = {
            type: this.expanded,
            utr_number: this.mode.utr_number,
            bank_name: this.mode.bank_name,
            receipt_number: this.mode.receipt_number,
            remarks: this.mode.remarks,
          };
          break;
        }
        case "ONLINE/NET BANKING": {
          transactionModeObject = {
            type: this.expanded,
            transaction_id: this.mode.transaction_id,
            bank_name: this.mode.bank_name,
            receipt_number: this.mode.receipt_number,
            remarks: this.mode.remarks,
          };
          break;
        }
        case "DEBIT CARD": {
          transactionModeObject = {
            type: this.expanded,
            transaction_id: this.mode.transaction_id,
            bank_name: this.mode.bank_name,
            receipt_number: this.mode.receipt_number,
            remarks: this.mode.remarks,
          };
          break;
        }
        case "CREDIT CARD": {
          transactionModeObject = {
            type: this.expanded,
            transaction_id: this.mode.transaction_id,
            bank_name: this.mode.bank_name,
            receipt_number: this.mode.receipt_number,
            remarks: this.mode.remarks,
          };
          break;
        }
        default: {
          return null;
        }
      }
      return transactionModeObject;
    },

    // async getFeeReceipt() {
    //   // var response = await api.call(this.essentials, "http://localhost:9000/erp/fees/receipt/24/");
    //   // var file = new File([response], "somefile.xlsx");
    //   // console.log(file);
    //   axios({
    //     url: "http://localhost:9000/erp/fees/receipt/24/", //your url
    //     method: "GET",
    //     responseType: "blob", // important
    //     headers: {
    //             Authorization: this.accessToken ? 'JWT ' + this.accessToken : null
    //         }
    //   }).then((response) => {
    //     const url = window.URL.createObjectURL(new Blob([response.data]));
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", "file.xlsx"); //or any other extension
    //     document.body.appendChild(link);
    //     link.click();
    //   });
    // },

    async getFinancePreferences(){
      var url = endpoints.financePreferences + `${this.currentInstitution.id}/`;
      this.financePreferences = await api.call(this.essentials,url)
      if(this.financePreferences?.link_fees){
        this.financeAccounts = await api.call(this.essentials,endpoints.financeAccounts);
      }
    },



    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        if (err.response.status == 409) {
          this.snackbar.text =
            "Receipt number is already used. Please use a different number";
          this.snackbar.visible = true;
        }
      } else {
        this.snackbar.message = "Unable to process request";
        this.snackbar.visible = true;
      }
    },
  },
  async created() {
    // Auto generated receipt number
    console.log("Here");
    console.log(this.feeCollectionData);
    await this.getAgrn();

    await this.getFinancePreferences();

    if(!this.feeCollectionData){
      this.$router.push({ name: "FeesRecord" });
      return;
    }
    if (!this.feeCollectionData.profile) {
      // end of flow.
      this.$router.push({ name: "FeesRecord" });
      return;
    }

    if(this.feeCollectionData.selected_fee_particular_tag && this.feeCollectionData.selected_fee_particular_tag?.preferred_fee_receipt_settings){
      this.selected_fee_receipt_settings = this.feeReceiptSettings.find(rs => rs.id == this.feeCollectionData.selected_fee_particular_tag.preferred_fee_receipt_settings); 
      this.setFeeReceiptNumber();
    }
  },
};
</script>

<style scoped>
.rounded-input {
  border-radius: 12px !important;
}
.payment-active {
  background-color: aqua;
  color: white;
}

.v-expansion-panel-header--active{
  margin-bottom: 10px;
}
</style>